import { useSelector } from 'react-redux';
import SaveJsonToBucketButton from '../../saveJsonToBucketButton/SaveJsonToBucketButton';
import { BOTS_IN_VC_FILE_NAME } from '../../teachingAssistantBotsList';
import classes from './SaveInVcBar.module.css';

const SaveInVcBar = ({
  onExportBotsInVc,
  canExportBotsInVc,
  getBotsInVcContent,
}) => {
  const { texts } = useSelector(state => state.translate);

  return (
    <div className={classes.Bar}>
      <p className={classes.Title}>{texts.saveInVc}</p>
      <div className={classes.Actions}>
        <SaveJsonToBucketButton
          saveKind="botsList"
          directory="VC"
          fileName={BOTS_IN_VC_FILE_NAME}
          getContent={getBotsInVcContent}
          buttonLabel={texts.saveBotsInVc}
          disabled={!canExportBotsInVc}
          confirmTitleId="save-bots-in-vc-confirm-title"
        />
        <button
          type="button"
          className={classes.Btn}
          onClick={onExportBotsInVc}
          disabled={!canExportBotsInVc}
        >
          {texts.downloadBotsInVc}
        </button>
      </div>
    </div>
  );
};

export default SaveInVcBar;
